import React, { useContext, useState } from 'react'
import { SwitchACtiveContext } from '../../Context/StartTrackingContext/SwitchActiveContext'
import "./MainPageListing.css"

function MainPageListing({setActive,active}) {
    const { 
        dispatch
       } = useContext(SwitchACtiveContext)

    //    show favorites
       const showFavorites = ()=>{
        dispatch({type: "SHOW_FAVORITES"  })
        setActive("Favorites")
       }

        //show hot
        const showHot = ()=>{
            dispatch({type: "SHOW_HOT"  })
            setActive("Hot")
           }

      //show gainers
      const showGainers = ()=>{
        dispatch({type: "SHOW_GAINERS"  })
        setActive("Gainers")
       }

       //show gainers
      const showLosers = ()=>{
        dispatch({type: "SHOW_LOSERS"  })
        setActive("Losers")
       }

      //show newlistings
      const showNewListings = ()=>{
        dispatch({type: "SHOW_NEWLISTINGS"  })
        setActive("New_Listings")
       }

  return (
    <div className='MainPageListing'>
        <div className='MainPageListing_container_list'>

                <div className={active === "Favorites" ? "element_active" : "container_lists"}
                    onClick={
                        showFavorites
                    }
                
                >
                    <p>Favorites</p>
                </div>
                
                <div className={active === "Hot" ? "element_active" : "container_lists"}
                    onClick={
                        showHot

                    }

                >
                    <p>Hot</p>
                </div>              

                <div className={active === "Gainers" ? "element_active" : "container_lists"}
                    onClick={
                        showGainers

                    }              
                >
                    <p>Gainers</p>
                </div>

                <div className={active === "Losers" ? "element_active" : "container_lists"}
                    onClick={
                        showLosers
                        
                    }
                
                >
                    <p>Losers</p>
                </div>

                <div  className={active === "New_Listings" ? "element_active" : "container_lists"} 
                    onClick={
                        showNewListings
                        
                    }

                >
                    <p>New_Listings</p>
                </div>

        </div>

    </div>
  )
}

export default MainPageListing
